import { createReducer } from "reduxsauce";
import { apiFetchedState, getInitialPendingState } from "@actions/redux.action";
import { brownLogisticsType } from "./actionTypes";

const initialState = {
  config: {
    data: {},
    api: getInitialPendingState(),
  },
};

const setSuccessStatus = (key, newStatus) => (state, action) => ({
  ...state,
  [key]: {
    ...state[key],
    data: action.payload,
    api: apiFetchedState(newStatus, state[key].api),
  },
});
const setStatus = (key, newStatus) => (state) => ({
  ...state,
  [key]: {
    ...state[key],
    api: apiFetchedState(newStatus, state[key].api),
  },
});

const actionHandlers = {
  [brownLogisticsType.GET_CONFIG_DATA_UPCOMING]: setStatus("config", {
    pending: true,
  }),
  [brownLogisticsType.GET_CONFIG_DATA_SUCCESS]: setSuccessStatus("config", {
    success: true,
  }),
  [brownLogisticsType.GET_CONFIG_DATA_ERROR]: setStatus("config", {
    error: true,
  }),
  [brownLogisticsType.GET_CONFIG_DATA_FETCHED]: setStatus("config", {
    fetched: true,
  }),
};

export default createReducer(initialState, actionHandlers);
